import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
// import FlipDown from "flipdown/dist/flipdown.js";
import '../../assets/scripts/jquery.share.min.js'

var swiper1 = new Swiper(".section1 .mySwiper", {
  direction: 'vertical',
  speed: 400,
  watchOverflow: true,
  autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
  },
})

var swiper2 = new Swiper(".section2 .mySwiper", {
  loop: true,
  speed: 400,
  watchOverflow: true,
  autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  pagination: {// 分页
    el: ".section2 .swiper-pagination",
    clickable: true,
  },
})

var swiper3 = new Swiper(".section5 .left .mySwiper", {
  loop: true,
  speed: 400,
  watchOverflow: true,
  autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  pagination: {// 分页
    el: ".section5 .left .swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
})

var swiper4 = new Swiper(".section5 .right .mySwiper", {
  loop: true,
  speed: 400,
  effect : 'fade',
  watchOverflow: true,
  autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  pagination: {// 分页
    el: ".section5 .right .swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
})

$('.section5 .video .video-play').on('click',function(){
  $('.section5').find('video')[0].play()
  $('.section5 .video .video-play').hide()
})


